import s from '../allservices.jsx'
import { getClientId, getClientSecret,buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
const getValidUseridService = (actionCallback, validUserId) => {
    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
    let gid = getClientId();
     let traceId = getClientId();
    fetch(plink + s.valid_user_id + "/" + validUserId, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'clientId': gid,
            'clientSecret': getClientSecret(gid, validUserId),
            'X-Trace-Id': traceId,
            'X-KlickEx-Client':buildClientHeader(),
        })
    })
        .then(res => {

            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getValidUseridService;


// WEBPACK FOOTER //
// ./src/services/components/valid_userid.jsx